import { render, staticRenderFns } from "./CollegeUserTestAttended.vue?vue&type=template&id=1ea94b23"
import script from "./CollegeUserTestAttended.vue?vue&type=script&lang=js"
export * from "./CollegeUserTestAttended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports